const auth0Config = {
  authClientID: process.env.AUTH_CLIENT_ID,
  authDomain: process.env.AUTH_DOMAIN,
  authAudience: process.env.AUTH_API_AUDIENCE,
}

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
}

// Stripe Connect (OAuth for Standard accounts). The client ID is public. The
// redirect URI is not configured: the dashboard always sends Stripe back to
// its own origin plus /sell/setup, so every origin it runs on has to be
// registered with that path in the Stripe account that owns the client ID.
const stripeConnectConfig = {
  clientId: process.env.STRIPE_CONNECT_CLIENT_ID,
}

const config = {
  firebaseConfig,
  auth0Config,
  stripeConnectConfig,
}

export default config
